import React from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

interface RiderAccessModalProps {
  isOpen: boolean;
  onConfirm: () => void;
}

const RIDER_LOGIN_URL = 'https://rider.ride-connect.app';

export const RiderAccessModal: React.FC<RiderAccessModalProps> = ({
  isOpen,
  onConfirm,
}) => {
  if (!isOpen) return null;

  const handleNavigateToRiderLogin = () => {
    // Navigate to rider login page
    window.location.href = RIDER_LOGIN_URL;
    // Also call onConfirm in case parent component needs to do cleanup
    onConfirm();
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex min-h-screen items-center justify-center p-4">
        {/* Backdrop */}
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />

        {/* Modal */}
        <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full p-6">
          {/* Icon and Header */}
          <div className="flex items-center mb-4">
            <div className="flex-shrink-0 mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-orange-100">
              <ExclamationTriangleIcon className="h-6 w-6 text-orange-600" />
            </div>
          </div>

          <div className="text-center mb-6">
            <h3 className="text-2xl font-bold text-gray-900 mb-2">
              Admin Panel Access Restricted
            </h3>
            <p className="text-gray-600 mb-4">
              This is the admin panel for stores and administrators only.
            </p>
            <p className="text-gray-700 font-medium">
              Riders should use the RideConnect mobile app or web platform to access their account.
            </p>
          </div>

          {/* Action Button */}
          <div className="flex justify-center">
            <button
              onClick={handleNavigateToRiderLogin}
              className="px-6 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors font-medium"
            >
              Take me to Rider login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
